import { render, staticRenderFns } from "./StorageDatatable.vue?vue&type=template&id=3b7ccb3c"
import script from "./StorageDatatable.vue?vue&type=script&lang=js"
export * from "./StorageDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports